"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _decorators = require("decorators");

var _class, _descriptor, _descriptor2, _descriptor3, _temp;

var ForumHeader = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(ForumHeader, _Component);

  function ForumHeader() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, ForumHeader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(ForumHeader)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "groupTitle", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "itemTitle", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "commentCount", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(ForumHeader, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_react.Fragment, null, this.groupTitle && _react.default.createElement("h2", null, this.groupTitle), _react.default.createElement("h1", null, this.itemTitle), _react.default.createElement("p", {
        className: "item-count"
      }, this.commentCount, " comment", this.commentCount == 1 ? '' : 's'));
    }
  }]);
  return ForumHeader;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "groupTitle", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "itemTitle", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "commentCount", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
exports.default = ForumHeader;